export interface Html5UploadState {
    name: string;
    creatives: Record<number, UploadCreative>;
}

export enum UploadStatus {
    PROGRESS = 'progress',
    SUCCESS = 'success',
    ERROR = 'error'
}

export type UploadCreative = {
    fileId: number;
    file?: File;
    id?: string;
    status: UploadStatus;
    name: string;
    thumbnailUrl?: string;
    creativeUrl?: string;
    width?: number;
    height?: number;
    errors?: string[];
};
